import { PolyScene } from "../../../scene/PolyScene";
import { JsonImportDispatcher } from "./Dispatcher";
import { ImportReport } from "./ImportReport";
import { TimeController } from "../../../scene/utils/TimeController";
export class SceneJsonImporter {
  constructor(_data, _options) {
    this._data = _data;
    this._options = _options;
    this.report = new ImportReport(this);
  }
  static async loadData(data, options) {
    const importer = new SceneJsonImporter(data, options);
    return await importer.scene();
  }
  scene() {
    const scene = new PolyScene();
    if (this._options) {
      if (this._options.sceneName) {
        scene.setName(this._options.sceneName);
      }
      if (this._options.measurePerformanceOnLoad == true) {
        scene.performance.start();
      }
    }
    scene.loadingController.markAsLoading();
    const properties = this._data["properties"];
    if (properties) {
      const maxFrame = properties["maxFrame"] || 600;
      scene.timeController.setMaxFrame(maxFrame);
      const maxFrameLocked = properties["maxFrameLocked"];
      if (maxFrameLocked) {
        scene.timeController.setMaxFrameLocked(maxFrameLocked);
      }
      const realtimeState = properties["realtimeState"];
      if (realtimeState != null) {
        scene.timeController.setRealtimeState(realtimeState);
      }
      scene.setFrame(properties["frame"] || TimeController.START_FRAME);
      const mainCameraPath = properties["mainCameraNodePath"] || properties["mainCameraPath"];
      if (mainCameraPath) {
        scene.camerasController.setMainCameraPath(mainCameraPath);
      }
    }
    scene.cooker.block();
    this._base_operations_composer_nodes_with_resolve_required = void 0;
    const dispatcher = new JsonImportDispatcher();
    const importer = dispatcher.dispatchNode(scene.root());
    if (this._data["root"]) {
      importer.process_data(this, this._data["root"]);
    }
    if (this._data["ui"]) {
      importer.process_ui_data(this, this._data["ui"]);
    }
    this._resolve_operation_containers_with_path_param_resolve();
    scene.loadingController.markAsLoaded();
    if (this._options) {
      if (this._options.nodeCookWatcher) {
        this._options.nodeCookWatcher(scene);
      }
      if (this._options.configureScene) {
        this._options.configureScene(scene);
      }
    }
    scene.cooker.unblock();
    return scene;
  }
  add_operations_composer_node_with_path_param_resolve_required(operations_composer_node) {
    if (!this._base_operations_composer_nodes_with_resolve_required) {
      this._base_operations_composer_nodes_with_resolve_required = [];
    }
    this._base_operations_composer_nodes_with_resolve_required.push(operations_composer_node);
  }
  _resolve_operation_containers_with_path_param_resolve() {
    if (!this._base_operations_composer_nodes_with_resolve_required) {
      return;
    }
    for (let operations_composer_node of this._base_operations_composer_nodes_with_resolve_required) {
      operations_composer_node.resolveOperationContainersPathParams();
    }
  }
}
